import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { gameStore, GameState } from '../game/store';
export function FloorCompleteScreen() {
  const [state, setState] = useState<GameState>(gameStore.getState());
  useEffect(() => gameStore.subscribe(setState), []);
  const handleContinue = () => {
    gameStore.addMessage('Floor 2 is not yet built. The System is... working on it.', 'system');
    gameStore.setState({
      phase: 'playing',
      floor: 1,
      currentZone: 'awakening'
    });
    window.dispatchEvent(new Event('reset-game'));
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="absolute inset-0 z-50 bg-black pointer-events-auto flex flex-col items-center justify-center px-6" data-id="element-30">
      <motion.div initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      delay: 0.4,
      duration: 0.8,
      type: 'spring'
    }} className="text-center mb-4" data-id="element-31">
        <div className="text-yellow-500 text-xs uppercase tracking-[0.5em] mb-3" data-id="element-32">
          Floor {state.floor} Cleared
        </div>
        <div className="text-7xl md:text-9xl font-black text-white tracking-tighter" style={{
        textShadow: '0 0 40px rgba(255,255,255,0.4), 0 0 80px rgba(220,38,38,0.3)'
      }} data-id="element-33">
          YOU WILL NOT BREAK ME
        </div>
      </motion.div>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 0.7
    }} transition={{
      delay: 1.0
    }} className="text-red-400 italic text-lg md:text-xl mb-12 tracking-wide" data-id="element-34">
        The Goblin King has been dethroned. The Dungeon takes notes.
      </motion.p>

      <motion.div initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 1.3
    }} className="flex flex-wrap gap-4 justify-center mb-12" data-id="element-35">
        {[{
        label: 'Kills',
        value: state.kills,
        color: 'text-red-400'
      }, {
        label: 'Peak Viewers',
        value: Math.floor(state.peakViewership).toLocaleString(),
        color: 'text-pink-400'
      }, {
        label: 'Gold',
        value: state.gold,
        color: 'text-amber-400'
      }, {
        label: 'Crates Destroyed',
        value: state.cratesDestroyed,
        color: 'text-orange-400'
      }, {
        label: 'Time',
        value: `${Math.floor(state.timeAlive / 60)}:${Math.floor(state.timeAlive % 60).toString().padStart(2, '0')}`,
        color: 'text-blue-400'
      }].map(s => <div key={s.label} className="border border-gray-800 bg-black/60 px-5 py-3 text-center" data-id="element-36">
            <div className={`text-2xl font-bold ${s.color}`} data-id="element-37">{s.value}</div>
            <div className="text-xs text-gray-500 uppercase tracking-wider mt-1" data-id="element-38">
              {s.label}
            </div>
          </div>)}
      </motion.div>

      <motion.button initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 1.6
    }} whileHover={{
      scale: 1.05,
      boxShadow: '0 0 40px rgba(220,38,38,0.5)'
    }} whileTap={{
      scale: 0.95
    }} onClick={handleContinue} className="px-12 py-5 bg-transparent text-red-400 font-black text-xl uppercase tracking-[0.3em] border-2 border-red-500/70 hover:border-red-400 hover:text-red-300 hover:bg-red-950/40 transition-all cursor-pointer" style={{
      textShadow: '0 0 15px rgba(220,38,38,0.6)'
    }} data-id="element-39">
        Descend to Floor 2
      </motion.button>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 0.3
    }} transition={{
      delay: 2.2
    }} className="mt-8 text-gray-600 text-xs uppercase tracking-widest italic" data-id="element-40">
        (Floor 2 is still under construction. The System is... working on it.)
      </motion.p>
    </motion.div>;
}